import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      login: (username, password) => {
        // 模拟网络延迟
        return new Promise<boolean>((resolve) => {
          setTimeout(() => {
            const isValid =
              username === process.env.REACT_APP_ADMIN_USERNAME &&
              password === process.env.REACT_APP_ADMIN_PASSWORD;

            if (isValid) {
              set({ isAuthenticated: true });
              console.log("登录成功");
            } else {
              console.log("用户名或密码错误");
            }

            resolve(isValid);
          }, 800); // 添加 800ms 延迟使加载状态更明显
        });
      },
      logout: () => {
        set({ isAuthenticated: false });
        console.log("已退出登录");
      },
    }),
    {
      name: "auth-storage",
    }
  )
);
